// extracted by mini-css-extract-plugin
export default {"header":"Navbar_header__Oc3bQ"};